import { useContext } from "react";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import update from "@beeldit/core/services/update";
import { DetailsByPageableActionContext } from "./DetailsByPageableActionContext";

function useUpdate() {
  const { element, setBackendFormErrors } = useContext(DetailsByPageableActionContext);
  const errorHandler = useErrorHandler();

  return (onSuccess: any) => {
    update("pages", element.id, element)
      .then((response: any) => {
        onSuccess(response.data);
      })
      .catch((error: any) => {
        errorHandler(error, setBackendFormErrors);
      });
  };
}

export default useUpdate;
